import '../sass/latest-news.scss';

function initLatestNewsSwipers() {
    document.querySelectorAll('.js-latest-news-swiper').forEach((el) => {
        const paginationEl = el.querySelector('.latest-news__pagination');
        if (!paginationEl) {
            return;
        }

        new Swiper(el, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                    pagination: {
                        enabled: true,
                    },
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                    pagination: {
                        enabled: false,
                    },
                },
            },
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLatestNewsSwipers);
} else {
    initLatestNewsSwipers();
}
